import MainLoadingComponent from "./MainLoadingComponent";

export default MainLoadingComponent;
